// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import { handleActions } from 'redux-actions';
import {
    GET_SOLD_TO_LIST_SUCCESS,
    GET_SHIP_TO_LIST_SUCCESS,
    POST_SOLD_TO_SHIP_TO_SUCCESS,
    CLEAR_SOLD_TO_SHIP_TO_MESSAGE,
    GET_ONSITE_SOLD_TO_SHIP_TO_SUCCESS,
} from './actions';

export interface SoldToListType {
    soldToCustomerNbr: string;
    customerName: string;
    countryCode: string;
    countryName: string;
    stateProvinceCode: string;
    stateProvinceName: string;
    addressLineOneText: string;
    addressLineTwoText: string;
    addressLineThreeText: string;
    cityName: string;
    postalCode: string;
    isDummy: boolean;
}

interface OnSiteSoldToShipToType {
    soldToCustomerNbr: string;
    shiptoCustomerNbr: string;
    soldToCustomerName: string;
    soldToEmail: string;
    soldToCountryCode: string;
    soldToCountryName: string;
    soldToStateProvinceCode: string;
    soldToStateProvinceName: string;
    soldToAddressLineOneText: string;
    soldToAddressLineTwoText: string;
    soldToAddressLineThreeText: string;
    soldToCityName: string;
    soldToPostalCode: string;
}

export interface ShipToListType {
    soldToCustomerNbr: string;
    shipToCustomerNbr: string;
    customerName: string;
    countryCode: string;
    countryName: string;
    stateProvinceCode: string;
    stateProvinceName: string;
    addressLineOneText: string;
    addressLineTwoText: string;
    addressLineThreeText: string;
    cityName: string;
    postalCode: string;
    isDummy: boolean;
}

export const INITIAL_STATE: {
    soldToList: SoldToListType[];
    shipToList: ShipToListType[];
    soldToShipToCreation: any;
    onSiteSoldToShipTo: OnSiteSoldToShipToType;
} = {
    soldToList: [],
    shipToList: [],
    soldToShipToCreation: undefined,
    onSiteSoldToShipTo: {
        soldToCustomerNbr: '',
        shiptoCustomerNbr: '',
        soldToCustomerName: '',
        soldToEmail: '',
        soldToCountryCode: '',
        soldToCountryName: '',
        soldToStateProvinceCode: '',
        soldToStateProvinceName: '',
        soldToAddressLineOneText: '',
        soldToAddressLineTwoText: '',
        soldToAddressLineThreeText: '',
        soldToCityName: '',
        soldToPostalCode: '',
    },
};

export type ManagePartnersStoreType = Readonly<typeof INITIAL_STATE>;

export default handleActions(
    {
        [GET_SOLD_TO_LIST_SUCCESS]: _getSoldToList,
        [GET_SHIP_TO_LIST_SUCCESS]: _getShipToList,
        [POST_SOLD_TO_SHIP_TO_SUCCESS]: _postSoldToShipToDetails,
        [CLEAR_SOLD_TO_SHIP_TO_MESSAGE]: _postSoldToShipToDetails,
        [GET_ONSITE_SOLD_TO_SHIP_TO_SUCCESS]: _getOnSiteSoldToList,
    },
    INITIAL_STATE
);

function _getSoldToList(
    state: ManagePartnersStoreType,
    { payload }: { payload: any }
): ManagePartnersStoreType {
    if (payload) {
        return { ...state, soldToList: payload };
    }
    return state;
}

function _getShipToList(
    state: ManagePartnersStoreType,
    { payload }: { payload: any }
): ManagePartnersStoreType {
    if (payload) {
        return { ...state, shipToList: payload };
    }
    return state;
}

function _postSoldToShipToDetails(
    state: ManagePartnersStoreType,
    { payload }: { payload: any }
): ManagePartnersStoreType {
    return { ...state, soldToShipToCreation: payload };
}

function _getOnSiteSoldToList(
    state: ManagePartnersStoreType,
    { payload }: { payload: any }
): ManagePartnersStoreType {
    if (payload) {
        return { ...state, onSiteSoldToShipTo: payload };
    }
    return state;
}
